import EnlilAxiosRestAPI from "../../../../util/EnlilAxiosRestAPI";
import EnterpriseComponent from "../../EnterpriseComponent";
import {V1EmployeeAdminRoleIDOCToArray} from "../../../../util/Payload";
import {v4 as uuidv4} from "uuid";

class EmployeeAdminRoleEnterpriseComponent extends EnterpriseComponent {
    performQuery = (page, pageSize, foreignKey) => {
        page = page || 1;
        pageSize = pageSize || this.getDefaultCacheSize();

        this.notifyLoadStartListeners();

        let idocResponse = this.getIDOCResponse() ?? "v1.Employee-004";

        let QBE = {
            "ShifamedMessage": {
                "-idoc": idocResponse,
                "-id": uuidv4(),
                "Employee": {
                    "_attributes": {
                        "limit": 1,
                        "sort": null,
                        "offset": 0
                    },
                    "QueryGroups": {
                        "QueryGroup": [
                            {
                                "Name": "QG1",
                                "Type": "QueryGroup",
                                "Operator": "AND",
                                "Membership": {
                                    "Member": [
                                        {
                                            "Type": "Attribute",
                                            "Name": "USID",
                                            "Value": foreignKey,
                                            "Operator": "EQUAL"
                                        }
                                    ]
                                }
                            }
                        ]
                    },
                    "AdminRole": {
                        "_attributes": {
                            "limit": pageSize,
                            "sort": this.getFormattedSortSpecification(),
                            "offset": (page - 1) * pageSize
                        },
                        "QueryGroups": {
                            "QueryGroup": [
                                {
                                    "Name": "primary",
                                    "Operator": "AND",
                                    "Type": "QueryGroup",
                                    "Membership": {
                                        "Member": []
                                    }
                                }
                            ]
                        }
                    }
                }
            }
        }
        let queryPayload = this.prepareQueryPayload();

        if (queryPayload.size > 0) {
            for (const [key, value] of queryPayload) {
                if (key.includes("_query")) continue;

                let operator = "EQUAL";
                if (queryPayload.get(key + "_query") !== undefined) {
                    operator = queryPayload.get(key + "_query")
                }
                QBE.ShifamedMessage.Employee.AdminRole.QueryGroups.QueryGroup[0].Membership.Member.push({
                    "Type": "Attribute",
                    "Name": key,
                    "Value": value,
                    "Operator": operator
                })
            }
        }

        EnlilAxiosRestAPI({
            method: "GET",
            url: "t3/v1/employees",
            json: true,
            params: {
                "QBE": btoa(JSON.stringify(QBE))
            },
            headers: {
                "idoc-response": idocResponse,
            },
        }).then(response => {
            this.fetchEnterpriseComponentSuccess(V1EmployeeAdminRoleIDOCToArray(response.data), page, pageSize);
        }).catch(error => {
            this.fetchEnterpriseComponentFailed(error);
        });
    };

    enterpriseComponentPostIDOC = () => {
        let payload = {};

        let employee = {};

        employee["USID"] = this.getEnterpriseObject().getEnterpriseComponent("Employee").getAttributeValue("USID");
        employee["AdminRole"] = {
            "USID": this.getAttributeValue("USID")
        }

        payload.ShifamedMessage = {};
        payload.ShifamedMessage["-idoc"] = "v1.Employee-004";
        payload.ShifamedMessage.Employee = employee;

        return payload;
    }

    performInsert() {
        let payload = this.enterpriseComponentPostIDOC();

        let options = {
            method: "PUT",
            url: "t3/v1/employees",
            json: true,
            data: payload,
            headers: {
                "idoc-request": "v1.Employee-004",
                "idoc-response": "v1.Employee-004"
            },
        };
        this.notifyInsertStartListeners();
        EnlilAxiosRestAPI(options)
            .then(response => {
                this.insertEnterpriseComponentSuccess(V1EmployeeAdminRoleIDOCToArray(response.data));
            })
            .catch(error => {
                this.insertEnterpriseComponentFailed(error);
            });
    };

    performDelete() {
        let payload = {
            "ShifamedMessage": {
                "-idoc": "v1.Employee-004",
                "Employee": {
                    "_attributes": {
                        "delete": false
                    },
                    "USID": this.getEnterpriseObject().getEnterpriseComponent("Employee").getAttributeValue("USID"),
                    "AdminRole": {
                        "_attributes": {
                            "delete": true
                        },
                        "USID": this.getAttributeValue("USID")
                    }
                }
            }
        }

        let options = {
            method: "DELETE",
            url: "t3/v1/employees",
            json: true,
            data: payload,
            headers: {
                "idoc-request": "v1.Employee-004"
            },
        };
        this.notifyDeleteStartListeners();
        EnlilAxiosRestAPI(options)
            .then(() => {
                this.deleteEnterpriseComponentSuccess();
            })
            .catch(error => {
                this.deleteEnterpriseComponentFailed(error);
            });
    };
}

export default EmployeeAdminRoleEnterpriseComponent;